import React from "react";
import { useEffect } from "react";

import Prism from "prismjs";
import "prismjs/components/prism-c";
import "prismjs/components/prism-cpp";
import "prismjs/themes/prism.css";

export default function CodeBox({ code }: { code: string }) {
  useEffect(() => {
    Prism.highlightAll();
  }, []);

  return (
    <pre>
      <code className="language-cpp">{code}</code>
    </pre>
  );
}
